export type TFilterOperator =
  | 'eq'
  | 'neq'
  | 'gt'
  | 'lt'
  | 'gte'
  | 'lte'
  | 'like'
  | 'ilike'
  | 'contains'
  | 'icontains'
  | 'in'
  | 'between'

export interface IFilter {
  field: string
  operator: TFilterOperator
  value: string | number | Date
}

export interface IFilterParams {
  filters: IFilter[] | []
  sort_by: string[] | []
  sort_desc: boolean[] | []
}

export const defaultFilterParams = {
  filters: [],
  sort_by: [],
  sort_desc: [],
}

export type TFilterType = {
  filterType: string
  filterField?: string
  value: string | number | boolean | Date
}
